
import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar,Row,Col,Form,FormGroup,ControlLabel,FormControl,InputGroup} from 'react-bootstrap'
// import {Box} from 'reactjs-admin-lte'
import {RadioGroup,Radio} from 'react-icheck'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'
import DatePicker from '../../../component/element/DatePicker'
import NewContractorModal from '../../hr/NewContractorModal'
import EmployeeModal from '../../hr/EmployeeModal'
// import WorkdocStore from '../../../stores/WorkdocStore'
import {connect} from 'react-redux'
class WorkJobAssignTaskModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.getInitState()
  }

  getInitState(){
    return {showPerson:false,personType:'employee',newJob:true,showLeader:false,bf_task_id:'',person:null,leader:null,totalCost:'',damageItem:null,data:this.getEmptyRowData(1)}
  }

  getEmptyRowData(number){
    return new Array(number).fill('').map((item,index)=>{
      return {taskName:'',taskValue:'',taskStatus:'0',detail:'',startDate:'',endDate:'',duration:''}
    })
  }

  loadTask(damageItem,jobData){
    if(jobData===undefined){
      this.setState(Object.assign(this.getInitState(),{damageItem:damageItem}))
    }else{
      this.setState(Object.assign(this.getInitState(),jobData,{newJob:false,damageItem:damageItem}))
    }
  }

  

  onPersonPlusClick(){

    this.setState({showPerson:true})
  }  

  onLeaderPlusClick(){
    this.setState({showLeader:true})
  }

  onContractorSelect(item){
    let {showPerson,showLeader} = this.state
    
    if(showPerson)
      this.setState({person:item})
    else if(showLeader)
      this.setState({leader:item})
  }

  onEmployeeSelect(item){
    let {showPerson,showLeader} = this.state
    if(showPerson)
      this.setState({person:item})
    else if(showLeader)
      this.setState({leader:item})
  }

  onAddRowClick(number){
    let {data} = this.state
    data = data.concat(this.getEmptyRowData(number))
    this.setState({data:data})
  }

  onTaskItemChange(index,value){
    let {data} = this.state

    data[index].taskName = value.label
    data[index].taskValue= value.value

    this.setState({data:data})
  }

  onSelectChange(index,value){
    let {data} = this.state
    data[index].taskStatus = value.value
    this.setState({data:data})
  }

  onPersonTypeChange(e,value){
    
    this.setState({personType:value})
  }

  onTotalCostChange(e){
    this.setState({totalCost:e.target.value})
  }

  onStartDateChange(index,date,dateMoment){
    let {data} = this.state
    
    data[index].startDate  = date
    this.setState({data:data})
  }

  onEndDateChange(index,date,dateMoment){
    let {data} = this.state

    let duration = moment.duration(dateMoment.diff(moment(data[index].startDate,'DD-MM-YYYY')));
    
    data[index].endDate  = date
    data[index].duration = duration.asDays()+1;
    this.setState({data:data})
  }

  onTextChange(index,e){
    let {data} = this.state
    data[index].detail = e.target.value
    this.setState({data:data})
  }

  onTrashClick(index){
    let {data} = this.state
    data.splice(index,1)
    this.setState({data:data})
  }

  onSave(){
    let {bf_task_id,person,leader,totalCost,data} = this.state
    if(this.props.onSave!==undefined){
      let postData = {bf_task_id:bf_task_id,person:person,leader:leader,totalCost:totalCost,data:data}
      this.setState({person:null,leader:null},()=>{
        this.props.onSave(postData)
        this.props.onHide()
      })        
    }
  }

  onDelete(){
    let {bf_task_id,person,leader,totalCost,data} = this.state

    if(this.props.onDelete!==undefined){
      this.props.onDelete({bf_task_id:bf_task_id,person:person,leader:leader,totalCost:totalCost,data:data})
      // this.props.onHide()
    }
  }

  getTaskOptions(){
    let {messages} = this.props
    return [{label:messages['Dismanling'],value:'dismanlingState'},
    {label:messages['Hit'],value:'hitState'},
    {label:messages['Trap'],value:'trapState'},
    {label:messages['Ground'],value:'groundState'},
    {label:messages['Mix Color'],value:'mixColorState'},
    {label:messages['Paint'],value:'paintState'},
    {label:messages['Assembly'],value:'assemblyState'},
    {label:messages['Polish'],value:'polishState'},
    {label:messages['Clean'],value:'cleanState'},
    {label:'QC',value:'qcState'}]
  }

  getStatusOption(){
    let {messages} = this.props
    return [{label:messages['Waiting Start'],value:'0'},
    {label:messages['Fixing'],value:'1'},
    {label:messages['Done'],value:'2'},
    {label:messages['Pause'],value:'3'},
    ]
  }

  getName(person){
    let name =''
    if(person){
      if(person.first_name!==undefined && person.first_name!=="")
        name = person.first_name +' ('+person.nick_name+') '+person.last_name
      else
        name = person.nick_name
    }
    return name
  }

  renderPMPerson() {
    let {showLeader} = this.props
    let {person,leader} = this.state
    return([
        <Col key={0} md={6} style={{display:(showLeader)?'block':'none'}}>
            <FormGroup
            controlId="formBasicText"            
          >
            <ControlLabel>ชื่อมอบหมายให้</ControlLabel>            
            <InputGroup>
              <FormControl 
                type="text"
                value={this.getName(leader)}
              />
              <InputGroup.Addon onClick={this.onLeaderPlusClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
            </InputGroup>
          </FormGroup>        
        </Col>,
        <Col key={1} md={6}>
        <FormGroup
          controlId="formBasicText"            
        >
          <ControlLabel>ชื่อผู้ปฎิบัติงาน</ControlLabel>            
          <InputGroup>
            <FormControl 
              type="text"
              value={this.getName(person)}
            />
            <InputGroup.Addon onClick={this.onPersonPlusClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
          </InputGroup>
        </FormGroup>          
      </Col>
    ])
  }

  renderJobControlPerson() {
    let {showLeader,messages} = this.props
    let {person,leader} = this.state
    return([
        <Col key={0} md={6}>
          <FormGroup
            controlId="formBasicText"            
          >
            <ControlLabel>{messages['Technician']}</ControlLabel>            
            <InputGroup>
              <FormControl 
                type="text"
                value={this.getName(person)}
              />
              <InputGroup.Addon onClick={this.onPersonPlusClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
            </InputGroup>
          </FormGroup>          
        </Col>,
        <Col key={1} md={6} style={{display:(showLeader)?'block':'none'}}>
            <FormGroup
            controlId="formBasicText"            
          >
            <ControlLabel>{messages['Inspector']}</ControlLabel>            
            <InputGroup>
              <FormControl 
                type="text"
                value={this.getName(leader)}
              />
              <InputGroup.Addon onClick={this.onLeaderPlusClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
            </InputGroup>
          </FormGroup>        
        </Col>
    ])
  }

  renderPerson(){
    let {messages,jobType} = this.props
    let {personType} = this.state
    return (
      <Row>
        <Col md={12}>
        <RadioGroup name="radio" value={personType} onChange={this.onPersonTypeChange.bind(this)}>
            <Radio
              value="contractor"
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' '+messages['Contractor']}
            />
            <Radio
              value="employee"
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' '+messages['Employee']}
            />            
        </RadioGroup>
        </Col>
        {jobType==='pmcontrol'
        ?this.renderPMPerson()
        :this.renderJobControlPerson()}
      </Row>
    )
  }

  renderRowData(){
    let {data} = this.state
    let {messages} = this.props
    return data.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td>
          <Select clearable={false}
                placeholder={messages['Select']}
                value={item.taskValue} 
                options={this.getTaskOptions()}
                onChange={this.onTaskItemChange.bind(this,index)}
                />
        </td>
        <td><FormControl placeholder={messages['Detail']+'...'} value={item.detail} onChange={this.onTextChange.bind(this,index)}/></td>
        <td>
          <DatePicker showIcon={false} value={item.startDate} onChange={this.onStartDateChange.bind(this,index)}/>
        </td>
        <td>
          <DatePicker showIcon={false} value={item.endDate} onChange={this.onEndDateChange.bind(this,index)}/>
        </td>        
        <td className='text-center'>
          {item.duration}
        </td>
        <td className='text-center'>
          <Select placeholder={messages['Select']} clearable={false} 
          value={item.taskStatus}
          options={this.getStatusOption()} 
          onChange={this.onSelectChange.bind(this,index)}
          />
        </td>
        <td className='text-center'>
          <Button bsStyle='link' onClick={this.onTrashClick.bind(this,index)}><FontAwesome className='text-red' name='trash'/></Button>
        </td>
      </tr>
    ))
  }

  renderTable(){
    let {messages} = this.props
    return (
      <div>
        <div >
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th className='text-center' style={{width:'30px'}}>{messages['No']}</th>
                <th  style={{width:'100px'}}>{messages['Job Step']}</th>
                <th>{messages['Detail']}</th>
                <th className='text-center' style={{width:'140px'}}>{messages['Start']}</th>
                <th className='text-center' style={{width:'140px'}}>{messages['Finish']}</th>
                <th className='text-center' style={{width:'60px'}}>{messages['Day']}</th>   
                <th className='text-center' style={{width:'140px'}}>{messages['Status']}</th>            
                <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>            
              </tr>
            </thead>        
            <tbody>
              {this.renderRowData()}
            </tbody>
          </table>
        </div>
        <div >
          <Button bsStyle='success' onClick={this.onAddRowClick.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
        </div>
      </div>
    )    
  }

  renderSummary(){
    let {showTask,messages} = this.props
    let {totalCost} = this.state
    return (
      <Row >
        <Col md={12} >        
          <Form inline className={showTask?'pull-right':''}>
            <FormGroup controlId="formInlineName">
              <ControlLabel>{messages['Wages Contractors']}</ControlLabel>
              {' '}
              <FormControl type="text" 
                className='text-right' placeholder="#####"
                value={totalCost}
                onChange={this.onTotalCostChange.bind(this)}
               />
            </FormGroup>            
          </Form>
        </Col>
      </Row>
    )
  }

  renderDeleteButton(){
    let {newJob} = this.state
    let {messages} = this.props
    if(!newJob){
      return (<Button bsStyle='danger' onClick={this.onDelete.bind(this)}><FontAwesome name='trash'/>&nbsp;{messages['Delete Data']}</Button>)
    }else{
      return ('')
    }
  }

  renderButton(){
    let {messages} = this.props
    return (
      <ButtonToolbar className={'pull-right'}>
        {this.renderDeleteButton()}
        <Button bsStyle='primary' onClick={this.onSave.bind(this)}><FontAwesome name='save'/>&nbsp;{messages['Save']}</Button>
        <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{messages['Cancel']}</Button>
      </ButtonToolbar>
    )
  }

  render(){
    let {show,title,showTask,messages} = this.props
    let {showPerson,showLeader,personType} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName={showTask?"midwidth-dialog":"smallwidth-dialog"}>
        <Modal.Header closeButton>
          <Modal.Title>{messages['Responsible Person']+' '+title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              {this.renderPerson()}
              {showTask?this.renderTable():''}              
              <NewContractorModal show={(showPerson&&personType==='contractor')} onSelect={this.onContractorSelect.bind(this)} 
              onHide={()=>{this.setState({showPerson:false,showLeader:false})}}
              />
              <EmployeeModal show={(showPerson&&personType==='employee')||showLeader} onSelect={this.onEmployeeSelect.bind(this)} 
              onHide={()=>{this.setState({showPerson:false,showLeader:false})}}
              />
        </Modal.Body>
        <Modal.Footer>
          {this.renderButton()}
        </Modal.Footer>
      </Modal> 
    )
  }
}
WorkJobAssignTaskModal.defaultProps = {
  showTask:true,  
  showLeader:false,
  jobType:'jobcontrol'
}


export default WorkJobAssignTaskModal = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobAssignTaskModal}),null,null,{withRef:true}
)(WorkJobAssignTaskModal);





// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobAssignTaskModal.js